export enum NoteType {
	Warn = "WARN",
	Info = "INFO",
	Error = "ERROR",
	Success = "SUCCESS"
}